/* eslint-disable import/no-anonymous-default-export */
import { Suspense } from "react";
import { BrowserRouter as Router, Routes } from "react-router-dom";
import Spin from "antd/es/spin";
import "antd/dist/antd.min.css";
import mainRoutes from "./routes";
import { useViewGlobal } from "./utilities/hooks/useView";

function App() {
  const { view } = useViewGlobal();
  return (
    <Suspense fallback={<div className="spin"><Spin /></div>}>
      <Router>
        <Routes>{mainRoutes(view)}</Routes>
      </Router>
    </Suspense>
  );
}
export default () => {
  return <App />;
};
